import uiRouter from '@uirouter/angularjs';

import { LaunchDarklyServiceModule } from 'services/access/launchDarkly/launchDarkly.service';

export const StoreCreditModule = angular
    .module('app.pages.storeCredit', [
        uiRouter,
        LaunchDarklyServiceModule
    ]).config(($stateProvider) => {
        'ngInject';

        $stateProvider.state('storeCredit', {
            parent: 'auth',
            name: 'storeCredit',
            resolve: {
                hasStoreCreditFeature: (launchDarklyService, $state) => {
                    launchDarklyService.getFeature('new-admin-features-enabled')
                        .then((feature) => {
                            if (!feature.includes('storeCredit')) {
                                return $state.go('dashboard');
                            }
                        });
                }
            }
        }).state('storeCredit.add', {
            name: 'storeCredit.add',
            params: {
                email: ''
            }
        }).state('storeCredit.detail', {
            url: '/storeCredit/:storeCreditId',
            name: 'storeCredit.detail'
        });
    }).name;


// WEBPACK FOOTER //
// ./src/app/pages/storeCredit/storeCredit.module.js